<template>
  <div class="tw:bg-white tw:p-4 tw:rounded-lg tw:shadow-lg tw:flex tw:flex-col tw:gap-4">
    <div class="tw:text-sm tw:text-gray-800 tw:bg-red-200 tw:rounded-lg tw:px-5 tw:py-4">
      <p class="notification tw:inline tw:mr-1" v-html="$t('rc_fop_other_info')" />
    </div>

    <div class="tw:w-full tw:h-[1px] tw:border-b tw:border-gray-500" />
    <SecondaryButton size="medium" class="tw:w-full" @click="openPaymentPageSoonExpired">{{
      `+ ${$t('payment_method_new_cta')}`
    }}</SecondaryButton>
  </div>
</template>
<script setup>
import SecondaryButton from '@/components/base/buttons/SecondaryButton.vue'

const emit = defineEmits(['openPaymentPageSoonExpired'])
const openPaymentPageSoonExpired = () => emit('openPaymentPageSoonExpired', 'wire_transfer')

defineProps({
  type: String,
  defaultPaymentMethod: Object,
  expirationDate: Date,
})
</script>
<style scoped>
.notification :deep(span) {
  font-weight: bold;
}
</style>
